import React, { useState } from 'react'

import { Moment } from 'moment'

import DatePicker from 'common/components/dataEntry/components/DatePicker'
import Input from 'common/components/dataEntry/components/Input'
import Button from 'common/components/general/Button'
import Icon from 'common/components/general/Icon'

import './SearchExpense.less'

interface SearchInputProps {
  onSearch: (value: ExpenseSearchValue) => void
  translate: (key: string) => string
  loading: boolean
}

type ExpenseSearchValue = {
  dateOfService: string | null
  lastModifiedAt: string | null
  inputSearch: string | null
}

const SearchInput: React.FC<SearchInputProps> = ({ onSearch, translate, loading }) => {
  const [inputSearchValue, setInputSearchValue] = useState<string | null>(null)
  const [dateSearch, setDateSearch] = useState<string | null>(null)
  const [lastModifiedAtSearch, setLastModifiedAtSearch] = useState<string | null>(null)
  const ENTER_KEY_CODE = 13

  const search = (e: any) => {
    const value = e.target.value
    setInputSearchValue(value ?? null)

    if (e.keyCode === ENTER_KEY_CODE) {
      onSearch({
        inputSearch: inputSearchValue,
        dateOfService: dateSearch,
        lastModifiedAt: lastModifiedAtSearch,
      })
    }
  }

  const onDateChange = (date: Moment | null, dateString: string) => {
    setDateSearch(dateString ?? null)
  }

  const onLastModifiedAtChange = (date: Moment | null, dateString: string) => {
    setLastModifiedAtSearch(dateString ?? null)
  }

  return (
    <div>
      <p>{translate('doc-review-dashboard.search-expenses.search-label')}</p>
      <div className="flex flex__space_between">
        <div className="width_30">
          <Input
            placeholder={translate('doc-review-dashboard.search-expenses.search-by-text')}
            suffix={searchIcon}
            onKeyUp={search}
            className="mr-8"
          />
        </div>

        <div className="width_30">
          <DatePicker
            onChange={onDateChange}
            placeholder={translate('doc-review-dashboard.search-expenses.search-by-date-of-service')}
          />
        </div>

        <div className="width_30">
          <DatePicker
            onChange={onLastModifiedAtChange}
            placeholder={translate('doc-review-dashboard.search-expenses.search-by-date-last-modified')}
          />
        </div>

        <Button
          type="primary"
          onClick={() =>
            onSearch({
              inputSearch: inputSearchValue,
              dateOfService: dateSearch,
              lastModifiedAt: lastModifiedAtSearch,
            })
          }
          loading={loading}
        >
          {translate('general.search')}
        </Button>
      </div>
    </div>
  )
}

const searchIcon = <Icon type="fal fa-search" fontAwesome />

export default SearchInput
